module.exports = __webpack_public_path__ + "img/C05TechAbacus_ua.1f832499.webp";